
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/komodo-defi-framework/api/legacy/my_swap_status",
      function () {
        return require("private-next-pages/en/docs/komodo-defi-framework/api/legacy/my_swap_status/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/komodo-defi-framework/api/legacy/my_swap_status"])
      });
    }
  